import { render } from "./PanelConfigurationLogo.vue?vue&type=template&id=9610f3c6&scoped=true"
import script from "./PanelConfigurationLogo.vue?vue&type=script&lang=js"
export * from "./PanelConfigurationLogo.vue?vue&type=script&lang=js"

import "./PanelConfigurationLogo.vue?vue&type=style&index=0&id=9610f3c6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9610f3c6"]])

export default __exports__